import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { BeraV2Service } from '@/infra/services/bera-v2';

import type { Response } from '@/types';

export interface RetryBeraPatchParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const JOB_SUMMARY_QUERY_KEY = 'bera_job_summary';

const RETRY_ERROR_MESSAGE = 'Failed to update the video';

const Service = BeraV2Service.getInstance();

export function useRetryBeraPatch() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: RetryBeraPatchParams) => Service.retryPatch(params),
		onSuccess: () => {
			queryClient.invalidateQueries([JOB_SUMMARY_QUERY_KEY]);
		},
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? RETRY_ERROR_MESSAGE));
		}
	});
}
